import * as React from 'react'
import Page from 'components/presenter/page/Page'
import { Paper } from '@material-ui/core'
import FillButton from 'components/presenter/buttons/FillButton'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import CreateShopDialog from 'components/container/page/location/CreateShopDialog'
import cn from 'classnames'
import ShopLocationsTable from 'components/container/page/location/ShopLocationTable'
import * as styles from './create.module.css'


const ChooseShopForm = ({onSelectAll, onSelect, selected}) => {
  const { t } = useTranslation()
  const [isDialogOpen, setDialogOpen] = React.useState(false)
  const handleClickOpenDialog = () => {
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }
  
  return (
    <Page className={styles.root} seoMeta={{
      title: t('jetso.chooseShop')
    }}>
      <div className={styles.pageContent}>
        <div className={styles.titleSection}>
          <div className={styles.titleRoot}>
            <h1 className={styles.title}>{t('jetso.chooseShop')}</h1>
            <p className={styles.subTitle}>{t('jetso.chooseShopDescription')}</p>
          </div>
          <FillButton 
            className={cn(styles.btnUpdate)}
            onClick={handleClickOpenDialog}
          >
            {t('shopLocation.createShop')}
          </FillButton>
        </div>
        <Paper className={styles.paper} elevation={2}>
          <ShopLocationsTable
            className={styles.table}
            mode='select'
            selected={selected}
            onSelect={onSelect}
            onSelectAll={onSelectAll}
            emptyHint={t('jetso.noShopChoose')}
          />
        </Paper>
      </div>
      {
        isDialogOpen
        ? <CreateShopDialog
            open
            onClose={handleCloseDialog}
            onCreate={handleCloseDialog}
          />
        : <></>        
      }
    </Page>
  )
}

export default ChooseShopForm